function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 8.0013C1.33203 5.4873 1.33203 4.22997 2.11336 3.4493C2.8947 2.66864 4.15136 2.66797 6.66536 2.66797H9.33203C11.846 2.66797 13.1034 2.66797 13.884 3.4493C14.6647 4.23064 14.6654 5.4873 14.6654 8.0013V9.33464C14.6654 11.8486 14.6654 13.106 13.884 13.8866C13.1027 14.6673 11.846 14.668 9.33203 14.668H6.66536C4.15136 14.668 2.89403 14.668 2.11336 13.8866C1.3327 13.1053 1.33203 11.8486 1.33203 9.33464V8.0013Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 2.66797V1.66797M11.3307 2.66797V1.66797M1.66406 6.0013H14.3307",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.f2f26014ad063829cc90c553fe651686.svg";
export { ForwardRef as ReactComponent };